import clone from "lodash/clone";
import cloneDeep from "lodash/cloneDeep";

/**
 * Filters an array of objects by property path and value.
 * @example
 * filterByPath(
 *   [{ a: { b: 3 }, c: 4 }, { a: 3 }, { h: { b:3 } }, { a: { b: 3, z: 5 }, c: 4 }],
 *   { "a.b": 3, "a":3 }
 * );
 * // returns [{ a: { b: 3 }, c: 4 }, { a: { b: 3, z: 5 }, c: 4 }, { a: 3 }]
 * @param {Object[]} objectArray - The array of objects to be filtered.
 * @param {Object} filters - An object of path{ dot separated string}, value{*} pairs.
 * Representing a path to a property and value to be filtered for.
 * Order of specifying the path, value pairs matters. Resolved value is expected to be a string
 * @returns {Object[]} - Returns filtered array of objects.
 **/
export function filterByPath(objectArray, filters) {
  try {
    const filtersArray = Object.keys(filters);
    // this caters to no filters selected

    if (!filtersArray.length) return objectArray;

    const result = filtersArray.reduce((filtered, path) => {
      if (path === "cycleAuthorId") {
        return filtered;
      }
      let value = filters[path];

      // Checks if value of filter is empty to represent all items
      if (value === "any" || value === "all") return filtered;

      if (path == "isEquippedLifting")
        value = value === "notEquipped" ? false : true;

      const filteredResults = filtered.filter((obj) => {
        const resolved = resolveObjectPath(obj, path);

        if (typeof value === "string") {
          const res = value
            .split(",")
            .some((val) => String(resolved).includes(val));
          return res;
        }
        return resolved === value;
      });

      return filteredResults;
    }, objectArray);

    return result;
  } catch (err) {
    console.log("Error: ", err);
    return objectArray;
  }
}

export function filterCyclesByPath(cycles, pfilters = {}, coachingPortal) {
  try {
    const clonedFilter = cloneDeep(pfilters);
    const { cycleAuthorId, likedByMe, name, owner } = clonedFilter;
    // These filter on the cycle, not the program
    delete clonedFilter.name;
    delete clonedFilter.owner;

    const mappedCycles = cycles.reduce((filtered, cycle) => {
      const newCycle = clone(cycle);
      newCycle.programs = filterByPath(cycle.programs, clonedFilter);
      if (newCycle.programs.length) {
        filtered.push(newCycle);
      }
      return filtered;
    }, []);

    if (coachingPortal) {
      const filterByPathQuery = {
        name: name || "any",
        "owner._id": owner || "any",
      };
      return filterByPath(mappedCycles, filterByPathQuery);
    }

    return mappedCycles;
  } catch (err) {
    console.log("Error: ", err);
    return cycles;
  }
}

/** SHOULD USE GET
 * Resolves object path, given as dot delimited string.
 * @example
 * // returns 3
 * resolveObjectPath({ a: { b: 3 }, c: 4 }, "a.b");
 * @param {Object} obj - The object whose path is to be resolved.
 * @param {string} path - A dot(.) delimited string.
 * @returns {*} - Returns the value at the object's path.
 **/
function resolveObjectPath(obj, path) {
  return path.split(".").reduce((resolved, key) => resolved[key], obj);
}
